export var defaultOption = {
    label: "ทั้งหมด",
    value: ""
};
